import styled from 'styled-components'

export const KpiStyles = styled.div`
  .kpi-page-container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: url('${STATIC_BASE_URL}/static/webapp/images/ui-signin-bg.png') no-repeat right top
      #12324d;
  }
  .kpi-page-container .app-title {
    color: #f8f8ff;
    font-size: 10em;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .kpi-page-container .app-logo {
    position: absolute;
    top: 70px;
    left: 100px;
  }
  .kpi-page-container .center-container {
    width: 100%;
    position: relative;
    top: 30%;
  }
  .odometer {
    color: #fff;
    font-size: 12em;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
  }
`
